import { useMutation } from "@tanstack/react-query";
import { ClearRuntimeCache } from "../Api";

export const useClearRuntimeCacheMutation = () => {
  return useMutation({
    mutationFn: (payload?: Parameters<typeof ClearRuntimeCache>[0]) =>
      ClearRuntimeCache(payload),
  });
};

export const useCacheService = (config?: any) => {
  const clearRuntimeCacheMutation = useClearRuntimeCacheMutation();

  return {
    clearRuntimeCacheMutation,
  };
};
